<template>
  <div class="label-wrapper">
    <div class="field__label label text-field__label">
      <label
        class="label__elm"
        :for="forName"
      >
        {{ displayLabel | capitalize }}
        <template v-if="info">
          <tg-popper :popup-text="info">
            <template #reference>
              <font-awesome-icon
                class="label__icon"
                icon="info-circle"
                fixed-witdth
              />
            </template>
          </tg-popper>
        </template>
      </label>
    </div>
  </div>
</template>

<script>
import TgPopper from '~/components/common/TgPopper';

export default {

  name: 'TgFormLabel',

  components: {
    TgPopper,
  },

  props: {
    forName: {
      type: [String, null],
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    info: {
      type: [String, Object],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    displayLabel () {
      let label = '';
      label += this.label;
      label += this.required ? ' *' : '';

      return label;
    },
  },
};
</script>

<style scoped>
.label >>> .popper-wrapper {
  margin-left: .25rem;
  display: inline-block;
}
</style>
